<template>

  <section class="list">

    <div v-for="(single, ID) in this.portfolio" :key="ID" class="list__single" :id="'portfolio-' + single.ID">
      <div class="list__single__info">
        <div class="list__single__info__top">
          <div class="list__single__info__what">{{ single.what }}</div>
          <h4 class="list__single__info__title">
            <router-link :to="'portfolio/' + single.slug">
              {{ single.title }}
            </router-link>
          </h4>
          <div class="list__single__info__type">{ {{ single.field }} }</div>
          <div class="list__single__info__description" v-html="single.excerpt"></div>
        </div>
        <div class="list__single__info__bottom">
          <div v-if="single.tags" class="list__single__info__tags">
            <div v-for="(tag, index) in single.tags" :key="index" class="list__single__info__tags__tag">
              {{ tag.name }}
            </div>
          </div>
          <router-link :to="'portfolio/' + single.slug" class="list__single__info__link">View Case Study</router-link>
        </div>
      </div>

      <router-link :to="'portfolio/' + single.slug" class="list__single__image">
        <img :src="single.image" :alt="single.title">
      </router-link>
    </div>

  </section>

</template>

<script>

  import PostService from '../PostService'
  const postService = new PostService()

  export default {
    name: 'PortfolioList',
    data() {
      return {
        portfolio: []
      }
    },
    created() {
      postService.getAllPosts()
        .then(result => {
          this.portfolio = result.data
        })
        // eslint-disable-next-line
        .catch(error => console.error(error))
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .list {
    @include container;
    flex-direction: column;

  }

  .list__single {
    display: flex;
    justify-content: space-between;
    padding: 100px 0;
    
    @include mq(medium) {
      padding: 60px 0;
    }

    @include mq(small) {
      flex-direction: column-reverse;
      padding: 50px 0;
      position: relative;
    }
  }

  .list__single__info {
    flex: 1;
    padding-right: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include mq(medium) {
      padding-right: 50px;
    }

    @include mq(small) {
      padding-right: 0;
    }
  }

  .list__single__info__top {
  }

  .list__single__info__bottom {

  }

  .list__single__info__what {
    @include ui(back);
    margin-bottom: 20px;

    @include mq(small) {
      position: absolute;
      top: 70px;
    }
  }

  .list__single__info__title a {
    @include title(small);
    text-decoration: none;
    margin-bottom: 20px;
    display: inline-block;

    @include mq(small) {
      margin-bottom: 10px;
    }
  }

  .list__single__info__type {
    @include current(big);
    font-size: 18px;
    margin-bottom: 20px;

    @include mq(small) {
      margin-bottom: 10px;
    }
  }

  .list__single__info__description {
    @include mq(medium) {
      margin-bottom: 20px;
    }

    @include mq(small) {
      margin-bottom: 10px;
    }
  }

  .list__single__info__tags {
    margin-bottom: 30px;
    display: flex;

    @include mq(large) {
      flex-direction: column;
    }

    @include mq(medium) {
      margin-bottom: 20px;
    }

    @include mq(small) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .list__single__info__tags__tag {
    color: $light;
    font-size: 12px;

    @include mq(small) {
      font-size: 10px;
    }

    &:after {
      content: "•";
      padding: 0 7px 0 2px;

      @include mq(large) {
        display: none;
      }

      @include mq(small) {
        display: inline;
        padding: 0 5px 0 0;
      }
    }

    &:last-child:after {
      content: "";
      padding: 0;
    }
  }

  .list__single__info__link {
    @include ui(big);
    text-decoration: none;
    position: relative;
    padding-right: 40px;
    padding-left: 10px;
    display: inline-block;
    background-color: $primary;

    &:after {
      content: '';
      position: absolute;
      top: 0;
      right: 5px;
      width: 30px;
      height: 30px;
      background: url('../assets/arrow--dark.svg') 50% 50% no-repeat;
      transition: all ease-in-out .2s;
      transform: rotate(-90deg);
    }

    &:hover:after {
      right: -10px;
    }
  }

  .list__single__image {
    flex: 2;
    text-align: right;

    @include mq(medium) {
      flex: 1;
    }

    @include mq(small) {
      margin: 0 -20px 20px;
    }
  }

</style>
